export default __webpack_public_path__ + "static/media/ccf4a8061dc46bdf.0de673d68bed5bc047183ad30b4b6c17.svg";